import React from 'react';
import Title from '../../title';
import View from './view';
import ReadCookie from '../../../functions/readcookies';
import Permission from '../../../functions/permission';

class PurchaseDetails extends React.Component {

  state = {
    load: false,
    message: '',
    allbranch: [], menuPermission: []
  }

  componentDidMount() {
    this.getBranchs();
    this.menuControl();
  }

  menuControl() {
    let menuPermission = Permission('purchase-details', this.props.menus);
    this.setState({ menuPermission })
  }


  getBranchs() {
    let data = (ReadCookie("branch"));
    if (data == 0) {
      this.setState({ permissionError: 'You not have permission to access this menu!!!' })
    }
    else {
      let branchId;
      let branchState;
      for (var i = 0; i < data.length; i++) {
        branchId = data[i].branch_id;
        branchState = data[i].state;
      }
      this.setState({ selectedBranch: branchId, permissionError: '', states: branchState })
    }
  }

  render() {
    let { load, message, branchOptions, selectedBranch } = this.state;
    return (
      <div>
        <Title title={'Purchase Details'} openDrawer={this.props.openDrawer} />
        { this.state.menuPermission.view ?
          (
            <div>

              <div style={{display: this.state.purchasedetailsview}}>
                { selectedBranch ?
                  (
                    <div>
                      <View menuPermission={this.state.menuPermission} branch={selectedBranch} purchasedetailsedit={this.state.purchasedetailsedit}
                            state={this.state.states} data={this.state.data} />
                    </div>
                  ) : (<div></div>)
                }
              </div>
              <center style={{color: 'red', fontSize: 16}}>{this.state.permissionError}</center>
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }
      </div>
    );
  }
}

export default PurchaseDetails;
